import React from "react";
import { Container, Header, List, Item, DeleteContainer } from "./styles";
import { MdClose } from "react-icons/md";
import { Modal } from "semantic-ui-react";
import Alert from "../Alert";
import { GrFormClose } from "react-icons/gr";

const EmailList = ({
  emails = [],
  setEmails,
  selectedEmails,
  setSelectedEmails,
  deleteMode = false,
  search,
}) => {
  const [filteredEmails, setFilteredEmails] = React.useState([]);
  const [deleteMail, setDeleteMail] = React.useState(null);
  const [isSuccess, setIsSuccess] = React.useState(false);

  const handleSelectEmail = id => {
    const newSelectedEmails = [...selectedEmails];
    if (newSelectedEmails.includes(id)) {
      newSelectedEmails.splice(newSelectedEmails.indexOf(id), 1);
    } else {
      newSelectedEmails.push(id);
    }
    setSelectedEmails(newSelectedEmails);
  };

  const removeEmail = id => {
    const emailRemove = filteredEmails[id];
    const newEmails = emails.filter(email => email !== emailRemove);
    setEmails(newEmails);
    //setDeleteMail(null);
    setIsSuccess(true);
  };

  const handleAll = () => {
    if (selectedEmails.length === emails.length) {
      setSelectedEmails([]);
      return;
    }

    const newSelectedEmails = [];
    for (let i = 0; i < emails.length; i++) {
      newSelectedEmails.push(i);
    }
    setSelectedEmails(newSelectedEmails);
  };

  const closeModalDelete = () => {
    setDeleteMail(null);
    setIsSuccess(false);
  };

  React.useEffect(() => {
    if (!search) {
      setFilteredEmails(emails);
      return;
    }
    const filtered = emails.filter(email => email.includes(search));

    setFilteredEmails(filtered);
    // }, [search, emails])
  }, []);

  return (
    <Container>
      <Header>
        <p>Email</p>
      </Header>
      <List>
        {deleteMode && (
          <Item>
            <div onClick={handleAll}>
              {deleteMode && (
                <input
                  type="checkbox"
                  checked={selectedEmails.length === emails.length}
                  onClick={handleAll}
                />
              )}
              <p>Selecionar todos</p>
            </div>
          </Item>
        )}
        {filteredEmails.map((email, index) => (
          <Item key={index}>
            <div onClick={() => handleSelectEmail(index)}>
              {deleteMode && (
                <input
                  type="checkbox"
                  checked={selectedEmails.includes(index)}
                  onClick={() => handleSelectEmail(index)}
                />
              )}
              <p>{email}</p>
            </div>
            <button onClick={() => setDeleteMail(index)}>
              <MdClose size={18} />
            </button>
          </Item>
        ))}
      </List>

      <Modal
        open={deleteMail !== null}
        onClose={closeModalDelete}
        size="tiny"
        style={{ width: "450px" }}
      >
        <DeleteContainer>
          <div className="header">
            {isSuccess ? "Colaborador Excluído" : "Excluir colaborador"}
            <button onClick={closeModalDelete}>
              <GrFormClose size={22} />
            </button>
          </div>
          {isSuccess ? (
            <Alert msg="Colaborador excluído com sucesso!" type="success" />
          ) : (
            <>
              <p>
                Tem certeza que quer excluir o colaborador de e-mail{" "}
                <strong>{filteredEmails[deleteMail] || ""}?</strong>
              </p>
              <div className="btn_container">
                <button onClick={closeModalDelete}>não</button>
                <button onClick={() => removeEmail(deleteMail)}>Sim</button>
              </div>
            </>
          )}
        </DeleteContainer>
      </Modal>
    </Container>
  );
};

export default EmailList;
